import React from 'react';
import { useLocation } from 'react-router-dom';
import { AdminSidebarContext, type AdminSidebarContextValue } from '@/contexts/AdminSidebarContext';

export function AdminSidebarProvider({ children }: { children: React.ReactNode }): React.JSX.Element {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const [isOpen, setIsOpen] = React.useState(false);

  React.useEffect((): void => {
    if (!isAdminRoute && isOpen) setIsOpen(false);
  }, [isAdminRoute, isOpen]);

  const value = React.useMemo<AdminSidebarContextValue>(
    () => ({
      isOpen,
      open: () => {
        setIsOpen(true);
      },
      close: () => {
        setIsOpen(false);
      },
      toggle: () => {
        setIsOpen((previous) => !previous);
      },
      isAdminRoute,
    }),
    [isOpen, isAdminRoute]
  );

  return <AdminSidebarContext.Provider value={value}>{children}</AdminSidebarContext.Provider>;
}
